module.exports = "./images/originOS6.svg";